(() => {
  const TRANSITION_MS = 300;
  const CYCLE_MS = 2800;

  const initializeRotator = (root = document) => {
    root.querySelectorAll('[data-novva-announcement-rotator]').forEach((rotator) => {
      if (rotator.dataset.novvaRotatorReady === 'true') return;

      const track = rotator.querySelector('.novva-announcement-rotator__track');
      const slides = Array.from(track?.querySelectorAll('.announcement-bar__slide') || []);
      if (!track || !slides.length) return;

      rotator.dataset.novvaRotatorReady = 'true';
      slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== 0)));

      if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const firstClone = slides[0].cloneNode(true);
      firstClone.setAttribute('aria-hidden', 'true');
      firstClone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      firstClone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      firstClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      track.appendChild(firstClone);

      let currentIndex = 0;
      const updateAccessibility = () => {
        slides.forEach((slide, index) => {
          const activeIndex = currentIndex === slides.length ? 0 : currentIndex;
          slide.setAttribute('aria-hidden', String(index !== activeIndex));
        });
      };

      const advance = () => {
        currentIndex += 1;
        updateAccessibility();
        track.style.transition = `transform ${TRANSITION_MS}ms ease`;
        track.style.transform = `translate3d(-${currentIndex * 100}%, 0, 0)`;

        if (currentIndex === slides.length) {
          window.setTimeout(() => {
            track.style.transition = 'none';
            currentIndex = 0;
            track.style.transform = 'translate3d(0, 0, 0)';
            updateAccessibility();
            track.getBoundingClientRect();
            track.style.transition = `transform ${TRANSITION_MS}ms ease`;
          }, TRANSITION_MS);
        }
      };

      window.setInterval(advance, CYCLE_MS);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeRotator(), { once: true });
  } else {
    initializeRotator();
  }

  document.addEventListener('shopify:section:load', (event) => initializeRotator(event.target));
})();
